export default __webpack_public_path__ + "static/media/cases1.30bc5b2e.webp";